import { useCallback, useEffect, useRef } from 'react';
import { ContentProps } from '../../newron-core';

type Props = {
  rowsToDisplay: number;
  selected: string[];
  isLoading: boolean;
  componentSettings: ContentProps['componentSettings'];
  updateSettings: ContentProps['updateSettings'];
  setRowsToDisplay: (rowsCount: number) => void;
  setSelected: (selected: string[]) => void;
};

export enum LeaderBoardSettings {
  RowsToDisplay = 'rowsToDisplay',
  SelectedProducts = 'selectedProducts',
}

export const useDataFromComponentSettings = ({
  rowsToDisplay,
  selected,
  isLoading,
  componentSettings,
  setRowsToDisplay,
  setSelected,
  updateSettings,
}: Props) => {
  const isDataFromComponentSettingsCopied = useRef(false);

  const storeSelectedProducts = useCallback(
    (shouldClear?: boolean) => {
      updateSettings({
        [LeaderBoardSettings.RowsToDisplay]: shouldClear ? [] : [rowsToDisplay.toString()],
        [LeaderBoardSettings.SelectedProducts]: shouldClear ? [] : selected,
      });
    },
    [rowsToDisplay, selected, updateSettings]
  );

  useEffect(
    function copyAndRemoveDataFromComponentSettings() {
      if (!isLoading && !isDataFromComponentSettingsCopied.current) {
        const rowsToDisplay = componentSettings[LeaderBoardSettings.RowsToDisplay];
        const selectedProducts = componentSettings[LeaderBoardSettings.SelectedProducts];

        rowsToDisplay?.length && setRowsToDisplay(parseInt(rowsToDisplay[0]));
        selectedProducts?.length && setSelected(selectedProducts);

        storeSelectedProducts(true);

        isDataFromComponentSettingsCopied.current = true;
      }
    },
    [isLoading, componentSettings, storeSelectedProducts]
  );

  return {
    storeSelectedProducts,
  };
};
